import { render, staticRenderFns } from "./de_attach_captain.vue?vue&type=template&id=6cf73bbe&scoped=true&"
import script from "./de_attach_captain.vue?vue&type=script&lang=js&"
export * from "./de_attach_captain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf73bbe",
  null
  
)

export default component.exports